/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function HeartHandshakeIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="heart-handshake"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M20 14L18.136 11.903C17.025 10.653 15.053 10.718 14.026 12.038L13.583 12.608C12.972 13.393 11.86 13.573 11.033 13.022C10.179 12.453 9.933 11.308 10.476 10.438L11.883 8.187C11.961 8.062 12.033 7.934 12.098 7.803L12.105 7.789C13.565 4.87 17.398 4.132 19.838 6.3L19.965 6.413C22.154 8.359 22.254 11.746 20.182 13.818L20 14" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16.5 16L16.976 16.272C18.544 17.168 20.424 15.756 20 14" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M13.86 18.363L14.406 18.701C15.959 19.662 17.895 18.256 17.464 16.482" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14.691 18.877C15.024 20.598 13.14 21.885 11.658 20.949L11.53 20.868C11.416 20.796 11.31 20.713 11.213 20.621L3.979 13.769C1.839 11.742 1.893 8.317 4.096 6.359C6.569 4.161 10.455 4.909 11.934 7.869L12 8" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
